import { withStyles } from '@material-ui/core/styles';
import MuiDialogContent from '@material-ui/core/DialogContent';

export const ErrorDialogContent = withStyles((theme) => ({
    root: {
        textAlign: 'center',
    },
}))(MuiDialogContent);

export const ErrorDialogTitle = withStyles((theme) => ({
    root: {
      backgroundColor: theme.palette.error.dark,
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: 'large'
    },
}))(MuiDialogContent);

export const NormalDialogContent = withStyles((theme) => ({
    root: {
        textAlign: 'center',
    },
}))(MuiDialogContent);

export const NormalDialogTitle = withStyles((theme) => ({
    root: {
      backgroundColor: theme.palette.info.dark,
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: 'large'
    },
}))(MuiDialogContent);